import {
  shopFMData
} from '../service/getData'
import {
  FM_SHOP_DETIALS,
  FM_SHOP_HEADER,
  ERROR_TIPS,
  APP_ALERT_SHOW,
  ALERT_SHOW_CLOSE,
  LOCATION_INFO,
  DESTINATION_SCENIC_SPOT_INFO
} from './mutation-types.js'
import {
  baseFMUrl
} from '../config/env'

export default {
  async verifyCode({commit, state},data) {
  var xhr = new XMLHttpRequest();
  xhr.responseType = 'json';
    xhr.open('POST', baseFMUrl+'/auth/send_sms_code',true);
    xhr.onload = function () {
      console.log(xhr.response);
    };
    xhr.onerror = function () {
      console.log("Oops, error");
    };

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {

        if (xhr.response.header.status !==200 ) {
          commit(ERROR_TIPS, xhr.response.header.msg);
        }
        console.log(xhr.response.data);
        // commit(ERROR_TIPS, xhr.response.header.msg);
      }
    }
    var formData = new FormData();
    formData.append('phone_number', data.phone_number);
    formData.append('type',""+ data.type);
    xhr.send( formData);
  // console.log("type"+_type);
  // xhr.send( 'phone_number='+data.phone_number+'&type='+data.type);
  },
/*  async saveAddress({
                      commit,
                      state
                    }) {

    if (state.removeAddress.length > 0) return;

    let addres = await getAddressList(state.userInfo.user_id);
    commit(SAVE_ADDRESS, addres);
  },*/
  async getMCShopDetials({commit, state},FMshopId) {
  var xhr = new XMLHttpRequest();
  xhr.responseType = 'json';
  commit(FM_SHOP_DETIALS, '');
    console.log("进入getMCShopDetials");
    let getMCShopDetials=await shopFMData(FMshopId);
    commit(FM_SHOP_DETIALS, getMCShopDetials.data);
    commit(FM_SHOP_HEADER, getMCShopDetials.header);
    console.log(getMCShopDetials);

    /*xhr.open('GET', 'http://192.168.25.106:3000/fm/find/shop/shopDetail?shopId=' + FMshopId, true);
    xhr.onload = function () {
      console.log(xhr.response);
    };
    xhr.onerror = function () {
      console.log("Oops, error");
      commit(FM_SHOP_HEADER, {"header":{"status":1000,"msg":"网络连接异常","request":"/fm/find/shop/shopDetail"}});
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        console.log(2222222222);
        commit(FM_SHOP_DETIALS, xhr.response.data);
        commit(FM_SHOP_HEADER, xhr.response.header);
      }
    }
    xhr.send();*/
  },
  alertShow({ commit }, value){
    commit("APP_ALERT_SHOW", value);
  },
  alertShowClose({commit}){
    commit("ALERT_SHOW_CLOSE");
  },
  updatePerson ({commit, state}) {
    axios.get('/bbg/user/user_base_info', {
      params: {
        uid: 22478849
      }
    }).then(function (response) {
      if (response.data.code == 8) {
        commit(UPDATE_PERSON, response.data.data);
      }
    });
  },
  // locationinfo({ commit }, value){
  //   commit("LOCATION_INFO", value);
  // },

}



/*
		return new Promise((resolve, reject) => {
			let requestObj;
			if (window.XMLHttpRequest) {
				requestObj = new XMLHttpRequest();
			} else {
				requestObj = new ActiveXObject;
			}

			let sendData = '';
			if (type == 'POST') {
				sendData = JSON.stringify(data);
			}
console.log(url);
			requestObj.open(type, url, true);
			// requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");application/json; charset=utf-8
    // requestObj.setRequestHeader("Content-type", "application/json; charset=utf-8");
				requestObj.send(sendData);

			requestObj.onreadystatechange = () => {
				if (requestObj.readyState == 4) {
					if (requestObj.status == 200) {
						let obj = requestObj.response;
						console.log(obj);
						if (typeof obj !== 'object') {
							obj = JSON.parse(obj);
						}
						resolve(obj);
					} else {
						reject(requestObj);
					}
				}
			}
		})

		*/



// WEBPACK FOOTER //
// ./src/store/action.js